<template>
  <div class="page browse-page">
    <div class="swiper-container">
      <div class="content" v-if="showContent">
        <h1>海量中国风格文化数据</h1>
        <p>多种文化风格和设计资源智能生成 / 多维度关联触达文化资源 / 多角度展示推介文化数据</p>
      </div>
      <swiper-navigation @change="swiperChange"/>
      <search-box @is-show="handleShowContent"/>
      <swiper
        :modules="modules"
        effect="fade"
        @swiper="onSwiper"
      >
        <swiper-slide>
          <div class="banner-mask">
            <video src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672646565701-banner-video1.mp4" autoplay muted
                   loop></video>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner-mask">
            <img src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672646034711-banner-picture2.jpg" alt="">
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div id="section1" class="section section1">
      <h1 class="section-title">五大类设计资源</h1>
      <p class="section-desc">实现文化资源的个性化智能推荐、改善设计素材的生成和分发对创意设计过程的各个环节提供支撑</p>
      <ul>
        <li v-for="(item, index) in projectList" :key="index" @click="router.push(item.routePath)">
          <img :src="item.image" alt=""/>
          <div class="text-area">
            <span class="project-name">{{ item.name }}</span>
            <!--            <span class="project-introduce">专题介绍</span>-->
          </div>
        </li>
      </ul>
    </div>

    <div class="section section-project" v-for="(item, index) in projects.slice(0, 5)" :key="index">
      <h1 class="section-title">{{ item.title }}</h1>
      <p class="section-desc">{{ item.desc }}</p>
      <project-card-list :project-list="item.listData"/>
    </div>

    <div class="section section2">
      <h1 class="section-title">中国风格门窗生成式设计探索</h1>
      <p class="section-desc">门窗是建筑的呼吸……</p>
      <div class="section-content">
        <video ref="videoRef" src="https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672695087808-special-video1.mp4"
               :controls="!showPauseBtn"></video>
        <img v-if="showPauseBtn" class="custom-button" src="@/assets/images/pause.png" alt="" @click="playVideo">
      </div>
    </div>

    <div class="section section-project" v-for="(item, index) in projects.slice(5, 9)" :key="index">
      <h1 class="section-title">{{ item.title }}</h1>
      <p class="section-desc">{{ item.desc }}</p>
      <project-card-list :project-list="item.listData"/>
    </div>

    <bottom-bar/>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import SwiperNavigation from '@/components/SwiperNavigation/index'
import BottomBar from '@/components/BottomBar/index'
import SearchBox from './components/SearchBox'
import ProjectCardList from './components/ProjectCardList'
import { Pagination, Autoplay, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper.scss'
import 'swiper/modules/pagination/pagination.scss'

const modules = [Pagination, Autoplay, EffectFade]
const router = useRouter()
const route = useRoute()

// 跳转
watch(route, () => {
  setTimeout(() => {
    if (route.query.sectionId === 'section1') {
      document.querySelector('#section1').scrollIntoView({ behavior: 'smooth' })
    }
  }, 300)
}, { immediate: true })

// 轮播图
let swiperRef = null

function swiperChange (type) {
  if (type === 'next') {
    swiperRef.slideNext()
  } else {
    swiperRef.slidePrev()
  }
}

function onSwiper (swiper) {
  swiperRef = swiper
}

const showContent = ref(true)

function handleShowContent (data) {
  showContent.value = data
}

// 五大类设计资源
const projectList = ref(
  [
    {
      image: require('@/assets/images/project1.png'),
      name: '陶瓷',
      routePath: '/projectDetail/pottery'
    },
    {
      image: require('@/assets/images/project2.png'),
      name: '家具',
      routePath: '/projectDetail/furniture'
    },
    {
      image: require('@/assets/images/project3.png'),
      name: '服装',
      routePath: '/projectDetail/clothing'
    },
    {
      image: require('@/assets/images/project4.png'),
      name: '手机',
      routePath: '/projectDetail/mobile'
    },
    {
      image: require('@/assets/images/project5.png'),
      name: '高铁',
      routePath: '/projectDetail/highSpeedRail'
    }
  ]
)

// 专题
const projects = [
  {
    title: '长沙窑创新专题',
    desc: '长沙窑，即长沙铜官窑，兴起于唐朝，是中国乃至世界釉下彩瓷的开拓者',
    listData: [
      {
        id: '75e02922b6924277b4b5028fb8dccfc6',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/001.jpg',
        name: '悠然自在',
        content: '生动飘逸笔法自然'
        // url: 'http://47.106.72.238:18032/crDetail/75e02922b6924277b4b5028fb8dccfc6'
      },
      {
        id: 'f44afe3206394dbbbe98ef053e5a99a7',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/003.jpg',
        name: '闲情野趣',
        content: '绘世间万物之景致'
        // url: 'http://47.106.72.238:18032/crDetail/f44afe3206394dbbbe98ef053e5a99a7'
      },
      {
        id: '554a05a991da4939b1ad20a5933fdc9a',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/013.jpg',
        name: '丹青妙笔',
        content: '饱览诗意古韵'
        // url: 'http://47.106.72.238:18032/crDetail/554a05a991da4939b1ad20a5933fdc9a'
      },
      {
        id: 'bdcdd5d256cc461ba8a29859ff441f22',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/014.jpg',
        name: '安居乐业',
        content: '观生活之意趣'
        // url: 'http://47.106.72.238:18032/crDetail/bdcdd5d256cc461ba8a29859ff441f22'
      }
    ]
  },
  {
    title: '青花瓷创新专题',
    desc: '青花瓷（blue and white porcelain），又称白地青花瓷，常简称青花，中国瓷器的主流品种之一',
    listData: [
      {
        id: '40d4d6cebd72406aa4e303a0150af027',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/FS-8102_03.jpg',
        name: '巧夺天工',
        content: '层次分明的纹饰工艺'
        // url: 'http://47.106.72.238:18032/crDetail/40d4d6cebd72406aa4e303a0150af027'
      },
      {
        id: 'e8f4d50b9db548f2a005f0c9d4162954',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/SK02.jpg',
        name: '异木奇花',
        content: '万千景色绘此间'
        // url: 'http://47.106.72.238:18032/crDetail/e8f4d50b9db548f2a005f0c9d4162954'
      },
      {
        id: 'd38061a4b25d4305bf352a6a6de13bba',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/SK020.jpg',
        name: '栩栩如生',
        content: '雕龙画凤涉笔成趣'
        // url: 'http://47.106.72.238:18032/crDetail/d38061a4b25d4305bf352a6a6de13bba'
      },
      {
        id: 'ee96929d8a6f494594a23f187cdfffd1',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/SK025-1.jpg',
        name: '珠光宝气',
        content: '精妙绝伦的装饰艺术'
        // url: 'http://47.106.72.238:18032/crDetail/ee96929d8a6f494594a23f187cdfffd1'
      }
    ]
  },
  {
    title: '中国古代传统服饰专题',
    desc: '中国服饰从夏商周、春秋战国、秦汉、魏晋南北朝、隋唐、宋、元、明、清，到近现代，都以鲜明特色为世界所瞩目，主要以汉服为主',
    listData: [
      {
        id: 'f30b2cd0017b4ebaba484b9167fab129',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672674445815-special-picture1.jpg',
        name: '蝉衫麟带',
        content: '风吹仙袂飘飘举'
      },
      {
        id: '224dc141ebd94bec98800f0c25bbb7a4',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672674646175-special-picture2.jpg',
        name: '暗花线袍',
        content: '萧萧英气欲凌云'
      },
      {
        id: 'b6ef29c256eb4d73a0b8a429fa3396e1',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672674866705-special-picture3.jpg',
        name: '栩栩如生',
        content: '扬眉转袖若飞雪'
      },
      {
        id: 'c503342d2d8541deb6f1e923deff972f',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672675116255-special-picture4.jpg',
        name: '珠光宝气',
        content: '绣罗衣裳照暮春'
      }
    ]
  },
  {
    title: '旗袍创新专题',
    desc: '旗袍，又称褀袍，中国和世界华人女性的传统服装，被誉为中国国粹和女性国服',
    listData: [
      {
        id: '75beda6adb5f470493a1ae09ab99513a',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672678551406-special-picture1.jpg',
        name: '姿美韵盈',
        content: '旗服溢彩衬娇莺'
      },
      {
        id: '5b9655e73b1e44d6906a46bb6adb5aa3',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672680616316-special-picture2.jpg',
        name: '锦露凝香',
        content: '镶嵌绲宕盘雕镂绣'
      },
      {
        id: 'e6bbc81724894af4b8070b8b21854795',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672683221336-special-picture3.jpg',
        name: '春风拂柳',
        content: '真丝云纱缎锦成'
      },
      {
        id: '9dc96fe1f5f44505b2f6824ac247be18',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672683824366-special-picture4.jpg',
        name: '一袭芳华',
        content: '独立解放而平等'
      }
    ]
  },
  {
    title: '清式家具创新专题',
    desc: '及至明清，中国传统家具发展至鼎盛时期，用料考究，雕饰精当，形成了鲜明的时代特色和艺术风格',
    listData: [
      {
        id: '',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672684590557-special-picture1.jpg',
        name: '山川悠远',
        content: '景色万千藏方寸之间'
      },
      {
        id: '',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672684704947-special-picture2.jpg',
        name: '观书藏经',
        content: '诗书画卷通古博今'
      },
      {
        id: '',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672684794897-special-picture3.jpg',
        name: '精巧细节',
        content: '画龙点睛的浮雕图案'
      },
      {
        id: '',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/16672684897337-special-picture4.jpg',
        name: '谈笑鸿儒',
        content: '家具中的气质'
      }
    ]
  },
  {
    title: '民族服饰动态专题',
    desc: '通过对布料动画的运用，欣赏民族服饰的精细结构与精美设计',
    listData: [
      {
        id: '072972818db74b9e8576bee63a800ff4',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667296766567序列 01_5.gif',
        name: '',
        content: '蛋青色提花生绫纱女单袄'
      },
      {
        id: 'b8742b4ca6ba41f8b7f1e83b663faa70',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667296807219序列 01_4.gif',
        name: '',
        content: '白缎绣珍禽花卉纹对襟挂穗大坎'
      },
      {
        id: 'f97a59de18ef493e9a3087656459c3b8',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667296820469序列 01_6.gif',
        name: '',
        content: '云南富宁彝族贴布蜡染女裙'
      },
      {
        id: '33b294aa740f40948abc14a348aa7366',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667296832336序列 01_7.gif',
        name: '',
        content: '黎族织锦筒裙'
      }
    ]
  },
  {
    title: '清代数字藏品专题',
    desc: '通过3D重建，多角度展示清代数字藏品',
    listData: [
      {
        id: '5d18e8b8ab4f4c87bf5e60c3dc375824',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667296845050序列 01.gif',
        name: '',
        content: '沉香木雕山水笔筒'
      },
      {
        id: '9dd1b4da88714d1aa806116e7c0c4097',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667296857501序列 01_1.gif',
        name: '',
        content: '乾隆金胎掐丝珐琅花瓶'
      },
      {
        id: '52f2297b32294b659024d7361157b0bb',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667296870127序列 01_2.gif',
        name: '',
        content: '乾隆御用款金碗'
      },
      {
        id: '8db56eecceeb4d4bae7317436104f406',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667296879939序列 01_3.gif',
        name: '',
        content: '清代肉型石'
      }
    ]
  },
  {
    title: '侗锦纹样专题',
    desc: '侗锦，侗族人民传承下来的民间工艺品，侗族织锦是侗族众多民间工艺品中的一个瑰宝。',
    listData: [
      {
        id: 'c2b23ae60b1b4a5d8e6c9acfdd94c2b2',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1690269390832zj1014Z原图.JPG',
        name: '花锦绚烂',
        content: '凤鸣八方声吹花锦'
        // url: 'http://47.106.72.238:18032/crDetail/c2b23ae60b1b4a5d8e6c9acfdd94c2b2'
      },
      {
        id: 'ecd5561e43e6454aa37049291000f87f',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1690269383840zj0005Z.1650x400.jpg',
        name: '耶罗素雅',
        content: '歌声飘远轻拂侗'
        // url: 'http://47.106.72.238:18032/crDetail/ecd5561e43e6454aa37049291000f87f'
      },
      {
        id: '22868255ad1043aa8fb6ac5c5389eea9',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1690269387476zj0006Z_页面_1.jpg',
        name: '鱼凤相映',
        content: '彩锦波浪灿烂光'
        // url: 'http://47.106.72.238:18032/crDetail/22868255ad1043aa8fb6ac5c5389eea9'
      },
      {
        id: 'da0d219894b7486b843f80be0c6f8419',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1690269379783bd10122_页面_1.jpg',
        name: '月华如锦',
        content: '花影随身舞照人间'
        // url: 'http://47.106.72.238:18032/crDetail/da0d219894b7486b843f80be0c6f8419'
      }
    ]
  },
  {
    title: '青铜器创新专题',
    desc: '中国青铜时代开始于公元前2000年，经夏、商、西周、春秋、战国和秦汉，历近15个世纪，是我国文化的重要组成部分，具有重要的历史价值和观赏价值。',
    listData: [
      {
        id: 'c2b23ae60b1b4a5d8e6c9acfdd94c2b2',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/815.jpg',
        name: '酒沽餮兽',
        content: '饕餮龙舟酒器功'
        // url: 'http://47.106.72.238:18032/crDetail/a4255430e0a44b02b671c69c8a454ac4'
      },
      {
        id: 'ecd5561e43e6454aa37049291000f87f',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1141.jpg',
        name: '象铜簋珍',
        content: '光华耀祭礼仪美'
        // url: 'http://47.106.72.238:18032/crDetail/d92783b7946c422092a912cb6fccaf9f'
      },
      {
        id: '22868255ad1043aa8fb6ac5c5389eea9',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1142.jpg',
        name: '虺虎钟威',
        content: '盘蛇喇叭钟鼎击'
        // url: 'http://47.106.72.238:18032/crDetail/46653adfc3314723a15e139edf2c3055'
      },
      {
        id: 'da0d219894b7486b843f80be0c6f8419',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1146.jpg',
        name: '雷觚角震',
        content: '青铜鼎足显威仪'
        // url: 'http://47.106.72.238:18032/crDetail/d2d8efda93df4b048f2d857f0960ace7'
      }
    ]
  }
]

// 视频播放
const videoRef = ref(null)
const showPauseBtn = ref(true)

function playVideo () {
  videoRef.value.play()
  showPauseBtn.value = false
}
</script>

<style lang="scss" scoped>
.browse-page {
  padding-top: 90px;
}

.swiper-container {
  position: relative;
  height: 900px;

  .swiper-slide img, .swiper-slide video {
    width: 100%;
    height: 900px;
    object-fit: cover;
  }

  .content {
    color: white;
    width: 1100px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;

    h1 {
      font-size: 64px;
      font-weight: 600;
      text-align: center;
      font-family: 'NotoSerifSC', system-ui;
      margin-bottom: 40px;
    }

    p {
      font-size: 24px;
      line-height: 45px;
      text-align: center;
    }
  }

  .navigation {
    position: absolute;
    z-index: 98;
    bottom: 44px;
    right: 90px;
  }

  .banner-mask:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    //background-color: rgba(0, 0, 0, .5);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.8) 68.23%);
  }
}

.search-box {
  position: absolute;
  z-index: 2;
  top: 183px;
  left: 50%;
  transform: translateX(-50%);
}

//五大类设计资源
.section1 {
  padding-left: 107px;
  padding-right: 107px;

  .section-desc {
    margin-bottom: 44px;
  }

  ul {
    display: flex;
    justify-content: space-between;

    li {
      //width: 333px;
      width: 24%;
      margin-right: 1%;
      cursor: pointer;

      &:last-of-type {
        margin-right: 0;
      }

      img {
        width: 100%;
        //width: 333px;
        height: 428px;
        border-radius: 10px;
        margin-bottom: 18px;
      }

      .text-area {
        display: flex;
        flex-direction: column;
        align-items: center;

        .project-name {
          font-size: 36px;
          font-weight: 600;
          line-height: 52px;
          font-family: 'NotoSerifSC', system-ui;
        }

        .project-introduce {
          font-size: 24px;
          font-weight: 400;
          line-height: 35px;
          color: #959595;
        }
      }
    }
  }
}

// 五个专题页
.section-project {
  .project-card-list {
    padding: 0 234px;
  }
}

// 中国风格门窗生成式设计探索
.section2 {
  .section-content {
    display: flex;
    justify-content: center;
    position: relative;

    video {
      width: 1004px;
      height: 565px;
    }

    .custom-button {
      width: 55px;
      height: 55px;
      position: absolute;
      z-index: 1;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
